module.exports = {
  ...require('./red_knight'),
  ...require('./rillifane_rallathil'),
}
